
export default {
  OldPass: '-',
   drawer: null,
  color: 'success',
  image: 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg',
  sidebarBackgroundColor: 'rgba(27, 27, 27, 0.74)'
}



// WEBPACK FOOTER //
// ./VueSrc/Common/Store/Security/PassChange_state.js